import FJTextContent from '../../../core/textBasedEditing/FJTextContent.js';
import {
    setEditFloatingPanelPosition,
    setEditFloatingPanelVisible,
    setShowDelete,
    setShowRestore,
} from '../../slices/FJSliceTextEditFloatingPanel.js';
import { MODAL_PARTICLE } from '../../../config/dataConfig/FJTextBasedEditingData.js';
import FJTextEditStore from '../../../store/FJTextBaseEditing/FJTextEditStore.js';
import FJActionRightTextBaseEditing from './FJActionRightTextBaseEditing.js';
import FJMessageStore from '../../../store/FJMessageStore.js';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJActionTextBasedEditing from './FJActionTextBasedEditing.js';
import FJTextBaseEditExportStore from '../../../store/FJTextBaseEditing/FJTextBaseEditExportStore.js';
import { setIsHideTextForDelete } from '../../slices/FJTextBasedEditing.jsx';

const _updateRightView = () => {
    return dispatch => {
        // TODO 右侧界面
        dispatch(FJActionRightTextBaseEditing.pauseAction());
        dispatch(FJActionRightTextBaseEditing.updateHasUndoRedoAction());
        dispatch(FJActionRightTextBaseEditing.updateSplitTimeListAction());
    };
};

const FJActionTextBasedEditingExtension = {
    updateFloatingPanelAction: () => {
        return (dispatch, getState) => {
            const { editTextPreviewId } = getState().textBasedEditing;
            const content = document.getElementById(editTextPreviewId);
            const offsetY = content ? content.scrollTop : 0;

            let hasDeleteGraph = false;
            let minX = 999999,
                minY = 999999,
                maxX = -999999;
            const list = FJTextContent.getSelectedTextList();
            list.forEach(graph => {
                if (graph.isHide) return;
                if (graph.isDelete) hasDeleteGraph = true;

                const rect = graph.getRect();
                minX = Math.min(minX, rect.x);
                minY = Math.min(minY, rect.y);
                maxX = Math.max(maxX, rect.x + rect.width);
            });

            if (minX !== 999999) {
                const boxRect = FJTextEditStore.getTextEditPreviewBoxRect(editTextPreviewId);
                dispatch(setShowRestore(hasDeleteGraph));
                dispatch(setShowDelete(!hasDeleteGraph));
                dispatch(setEditFloatingPanelVisible(true));
                dispatch(
                    setEditFloatingPanelPosition({
                        x: Math.round(minX + (maxX - minX) / 2 + boxRect.x),
                        y: Math.round(minY - offsetY + boxRect.y),
                    }),
                );
            }
        };
    },
    //#region hover到去掉填充词上
    showIgnoreWordAction: () => {
        return (dispatch, getState) => {
            const language = getState().textBasedEditing.selectedLanguage;
            const modalParticleList = MODAL_PARTICLE[language];
            if (!modalParticleList) return;

            const list = FJTextContent.getAllTextList();
            list.forEach(textGraph => {
                if (modalParticleList.findIndex(w => textGraph.isMatchText(w, true)) !== -1) {
                    textGraph.isMark = true;
                    textGraph.renderHighLight('#efff00');
                }
            });
        };
    },
    hideIgnoreWordAction: () => {
        return (dispatch, getState) => {
            const language = getState().textBasedEditing.selectedLanguage;
            const modalParticleList = MODAL_PARTICLE[language];
            if (!modalParticleList) return;

            const list = FJTextContent.getAllTextList();
            list.forEach(textGraph => {
                textGraph.isMark = false;
                textGraph.renderStyle();
            });
        };
    },
    //#endregion
    // 切换是否显示或隐藏已删除的文字的状态
    switchToDisplayTextOfDeleteAction: () => {
        return (dispatch, getState) => {
            if (getState().textBasedEditing.searchText) dispatch(FJActionTextBasedEditing.onSearchAction(''));
            FJTextContent.deSelectAll();
            const isHideTextForDelete = getState().textBasedEditing.isHideTextForDelete;
            dispatch(setIsHideTextForDelete(!isHideTextForDelete));
            dispatch(setEditFloatingPanelVisible(false));
            const list = FJTextContent.getDeleteTextList();
            if (list.length > 0) {
                dispatch(FJActionTextBasedEditing.renderAction());
                dispatch(FJActionRightTextBaseEditing.updateSelectedTimesAction());
            } else {
                FJTextContent.renderStyle();
            }
        };
    },
    downloadTextAction: () => {
        return dispatch => {
            FJTextEditStore.downloadText();
        };
    },
    removeMarkTextAction: () => {
        return (dispatch, getState) => {
            if (getState().textBasedEditing.searchText) dispatch(FJActionTextBasedEditing.onSearchAction(''));
            const isHideTextForDelete = getState().textBasedEditing.isHideTextForDelete;
            FJTextEditStore.deleteMarkText(isHideTextForDelete);
            // 如果是隐藏删除的文字,则需要更新换行符的显示和隐藏
            if (isHideTextForDelete) FJTextContent.updateLineBreak();
            // 如果是隐藏删除的文字，则需要把浮动面板关闭
            if (isHideTextForDelete) dispatch(setEditFloatingPanelVisible(false));
            dispatch(setShowRestore(true));
            dispatch(setShowDelete(false));
            // TODO 右侧界面
            dispatch(_updateRightView());
            dispatch(FJActionTextBasedEditingExtension.updateFloatingPanelAction());
        };
    },

    deleteTextAction: () => {
        return (dispatch, getState) => {
            if (FJTextBaseEditExportStore.isExport()) return;
            const result = FJTextEditStore.checkCanBeDelete();
            if (!result) {
                FJMessageStore.addMessage(
                    FJLocalStore._('deletion-failed-the-clip-is-too-short-after-deletion'),
                    'error',
                );
                return;
            }

            const isHideTextForDelete = getState().textBasedEditing.isHideTextForDelete;
            FJTextEditStore.deleteSelectedText(isHideTextForDelete);
            // 如果是隐藏删除的文字,则需要更新换行符的显示和隐藏
            if (isHideTextForDelete) FJTextContent.updateLineBreak();
            // 如果是隐藏删除的文字，则需要把浮动面板关闭
            if (isHideTextForDelete) dispatch(setEditFloatingPanelVisible(false));
            dispatch(setShowRestore(true));
            dispatch(setShowDelete(false));
            // TODO 右侧界面
            dispatch(_updateRightView());
            dispatch(FJActionTextBasedEditingExtension.updateFloatingPanelAction());
        };
    },
    restoreTextAction: () => {
        return dispatch => {
            FJTextEditStore.restoreSelectedText();
            dispatch(setShowRestore(false));
            dispatch(setShowDelete(true));
            // TODO 右侧界面
            dispatch(_updateRightView());
            dispatch(FJActionTextBasedEditingExtension.updateFloatingPanelAction());
        };
    },
    // 定位文字
    positionTextAction: selectedText => {
        return (dispatch, getState) => {
            if (getState().textBasedEditing.activePanelName !== 'edit') return;
            const boxId = getState().textBasedEditing.editTextPreviewId;
            const content = document.getElementById(boxId);
            if (!content) return;
            if (!selectedText) {
                const selectedList = FJTextContent.getSelectedTextList();
                if (!selectedList || selectedList.length === 0) return;
                selectedText = selectedList[0];
            }

            const displayRange = { min: content.scrollTop, max: content.scrollTop + content.clientHeight };
            const rect = selectedText.getRect();
            if (rect.y < displayRange.min) {
                content.scrollTop = rect.y - 5;
            } else if (rect.y + rect.height > displayRange.max) {
                content.scrollTop = rect.y + rect.height - content.clientHeight + 100;
            }
        };
    },
};

export default FJActionTextBasedEditingExtension;
